// src/components/Services.jsx

import React from "react";
import FeatureCard from "./FeatureCard";
import "./Services.css";
import { Slide } from "react-awesome-reveal";
const Services = () => {
  const servicesData = [
    {
      title: "Gestão de Banco de Dados",
      description:
        "Estruturamos e administramos bancos de dados robustos, seguros e escaláveis, assegurando alta disponibilidade e monitoramento contínuo para suportar o crescimento do seu negócio.",
      iconName: "app-development",
    },
    {
      title: "Engenharia de Dados",
      description:
        "Criamos pipelines inteligentes, integramos múltiplas fontes e aplicamos governança de dados, preparando informações estratégicas para análises consistentes e decisões assertivas.",
      iconName: "data-engineering",
    },
    {
      title: "Analytics & Inteligência Artificial",
      description:
        "Aplicamos analytics avançado e algoritmos de IA para transformar grandes volumes de dados em inteligência de negócio, antecipando tendências e otimizando resultados.",
      iconName: "machine-learning",
    },
    {
      title: "Desenvolvimento de Software Inteligente",
      description:
        "Desenvolvemos sistemas e softwares sob medida, impulsionados por inteligência artificial, que aumentam a eficiência, automatizam processos e geram inovação sustentável.",
      iconName: "Desenvolvimento",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="benefits-header">
          <h2>
            Nossas <span className="highlight">Soluções</span>
          </h2>
          <p>
            Oferecemos um portfólio completo de serviços e soluções para
            otimizar, proteger e potencializar o uso de dados na sua empresa.
          </p>
        </div>
        {/* <h2 className="services-title">
          <span className="primary-color">Nossas </span>
          <span className="secondary-color">Soluções</span>
        </h2>
        <p className="services-intro">
          Oferecemos um portfólio completo de serviços e soluções para otimizar,
          proteger e potencializar o uso de dados na sua empresa.
        </p> */}
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <Slide
              key={service.title}
              delay={index * 100}
              direction={index % 2 === 0 ? "left" : "right"} // Esquerda para par, direita para ímpar
              triggerOnce
            >
              <FeatureCard {...service} />
            </Slide>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
